export enum  StateFile {
    END_QUEUE_1 = 1,
    FINNALY = 2,
    INVALID_EXTENSION = 3,
    DUPLICATE = 4,
    ENCRYPTED = 5,
    CORRUPTED = 6,
    CONVERTED = 7,
    MERGED = 8,
    MAX_SIZE_LIMIT = 9,
  }
